module.exports = __webpack_public_path__ + "img/05.d959ba38.png";